export const PRIVACY_POLICY_URL =
  'https://league.com/ca/privacy-policy/?isapp=1';
export const PRIVACY_POLICY_FR_URL =
  'https://league.com/ca/privacy-policy-fr/?isapp=1';
export const PRIVACY_POLICY_ES_URL =
  'https://league.com/privacy-policy-es/?isapp=1';
export const LATEST_TERMS_VERSION = '1.0.1';
